import React from 'react'

const Hero = ({context}) => {

    const {org,config}=context

    return(
        <section className={`hero hero-style-3`}>
            <div className="hero-slider">
                <div className="slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-7 slide-caption">
                                <div className="slide-top">
                                    <span>{org.name}</span>
                                </div>
                                <div className="slide-title">
                                    <h2>{config["hero.title"] || org.name}</h2>
                                </div>
                                <div className="slide-subtitle">
                                    <p>{config["hero.description"]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-vec d-none d-md-flex">
                        <img src={org.logo} alt=""/>
                        <div className="right-border">

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;
